module.exports = __webpack_public_path__ + "static/media/footerImage.2f5f3967.svg";